export default "__VITE_ASSET__Bzx6SC2x__"